import { OrchestrationStep, PolicyComponents, UserJourney } from './interfaces';
import { Node } from 'react-flow-renderer';
import { init_DiamondNode, init_Edge, init_Node } from './initInterfaces';
import { GraphicEq, Label } from '@material-ui/icons';
import { ConstructionOutlined } from '@mui/icons-material';

// interface OrchestrationStep {
//     order: number,
//     type: string,
//     contentDefinitonReferenceId: string,
//     cpimIssuerTechnicalProfileReferenceId: string,
//     preconditions: Array<Precondition>,
//     claimsProviderSelections: ProviderSelections,
//     claimsExchanges: Array<ClaimsExchange>,
//     subJourneyToInvoke: string
// }
// interface UserJourney {
//     id: string,
//     defaultCpimIssuerTechnicalProfileReferenceId: string,
//     authorizationTP: string,
//     orchestrationSteps: Array<OrchestrationStep>
// }

function createNode(parentId: string, id: string, label: string, x: number, y: number, subJourney: string) {
  let node = init_Node();
  node.parentId = parentId;
  node.id = id;
  node.data.label = label;
  node.data.subJourney = subJourney;
  node.position.x = x;
  node.position.y = y;
  return node;
}
function createPreconditionNode(id: string, label: string, x: number, y: number) {
  let node = init_DiamondNode();
  node.id = id;
  node.data.label = label;
  node.position.x = x;
  node.position.y = y;
  return node;
}
function createEdge(id: string, src: string, target: string) {
  let edge = init_Edge();
  edge.id = 'edge-' + id;
  edge.source = src;
  edge.target = target;
  edge.style = { stroke: 'green' };
  edge.sourceHandle = 'down';
  return edge;
}
function createRightEdge(id: string, src: string, target: string) {
  let edge = init_Edge();
  edge.id = 'edge-' + id;
  edge.source = src;
  edge.target = target;
  edge.style = { stroke: 'red' };
  return edge;
}

function createPreconditionLabel(type: string, executeActionsIf: boolean, values: string[]) {
  let label = 'Error';
  executeActionsIf = !executeActionsIf;
  if (type == 'ClaimsExist') {
    label = values[0] + ' exists';
    if (executeActionsIf == false) label = values[0] + ' does not exist';
  } else if (type == 'ClaimEquals') {
    label = values[0] + ' == ' + values[1];
    if (executeActionsIf == false) label = values[0] + ' != ' + values[1];
  } else {
    // console.log('Unknown Precondition Type: ', type);
    alert('Unknown Precondition Type: ' + type);
  }
  return label;
}
function createOrchStepLabel(orchStep: OrchestrationStep) {
  let label = 'Error';
  if (orchStep.type == 'ClaimsExchange') {
    label = orchStep.claimsExchanges[0].technicalProfilerefrenceId; // or id  or technicalProfilerefrenceId
  } else if (orchStep.type == 'CombinedSignInAndSignUp') {
    //Alternatively orchStep.claimsExchanges[0].technicalProfilerefrenceId is also available to be used
    if (orchStep.claimsExchanges && orchStep.claimsExchanges.length) {
      label = orchStep.claimsExchanges[0].technicalProfilerefrenceId; // 'CombinedSignInAndSignUp';
    } else {
      // Some CombinedSignInAndSignUp steps don't define claimsExchanges, fall back to something though it may not be unique.
      label = 'CombinedSignInAndSignUp_' + orchStep.order.toString();
    }
  } else if (orchStep.type == 'InvokeSubJourney') {
    label = 'InvokeSubJourney_' + orchStep.subJourneyToInvoke;
  } else if (orchStep.type == 'SendClaims') {
    label = orchStep.cpimIssuerTechnicalProfileReferenceId;
  } else if (orchStep.type == 'ClaimsProviderSelection') {
    label = 'ClaimsProviderSelection';
  } else {
    // console.log('Unknown OrchestrationStep Type: ', orchStep.type);
    alert('Unknown OrchestrationStep Type: ' + orchStep.type);
  }
  return label;
}

export function convertJsonPolicyToGraph(userJourneys: UserJourney[], ujIndex: number) {
  let isDebugPolicy = false;
  for (let i = 0; i < userJourneys[ujIndex].orchestrationSteps.length && isDebugPolicy == false; i++) {
    let orchstep = userJourneys[ujIndex].orchestrationSteps[i];
    if (
      orchstep.type == 'ClaimsExchange' &&
      orchstep.claimsExchanges[0].technicalProfilerefrenceId.toLocaleLowerCase().startsWith('debug-')
    ) {
      isDebugPolicy = true;
    }
  }
  // let graph = convertUserJourneysToGraph(policyJSON.userJourneys);
  let graph = convertOrchestrationStepsToGraph(userJourneys[ujIndex].orchestrationSteps); //2 works

  return { ...graph, isDebugPolicy };
}

// "CombinedSignInAndSignUp"

//if prev was combined or claimsExchanges>1
//claimsExchanges for all
export function convertOrchestrationStepsToGraph(orchestrationSteps: Array<OrchestrationStep>) {
  let EdgeId = 0;
  let PreConditionID = 0;
  let Y = 0;
  let nX = 0;
  let pX = 26;
  let nodes = [];
  let edges = [];
  let precondtionNodesTobeConnected = [];
  let previousNodesTobeConnected = [];

  //First Node
  let hasPrecondition = orchestrationSteps[0].preconditions.length > 0;
  let prevPreconditionNode = null;
  let preconditionNode = null;
  if (hasPrecondition) {
    //for all preconditions
    // if (preconditionNode) add edge between preconditions
    for (let i = 0; i < orchestrationSteps[0].preconditions.length; i++) {
      let precondition = orchestrationSteps[0].preconditions[i];
      prevPreconditionNode = preconditionNode;
      preconditionNode = createPreconditionNode(
        'precondition' + '-0-' + i.toString(), // orchstep-nthprecondition
        createPreconditionLabel(precondition.type, precondition.executeActionsIf, precondition.values),
        pX,
        (Y += 200),
      );
      if (prevPreconditionNode) {
        edges.push(createEdge(String(EdgeId++), prevPreconditionNode.id, preconditionNode.id));
      }
      nodes.push(preconditionNode);
      precondtionNodesTobeConnected.push(preconditionNode.id);
    }
  }
  let prevNode = createNode(
    String(orchestrationSteps[0].order),
    String(orchestrationSteps[0].order),
    createOrchStepLabel(orchestrationSteps[0]),
    nX,
    (Y += 200),
    String(orchestrationSteps[0].subJourneyToInvoke),
  );
  if (prevNode.data.label.toLowerCase().startsWith('debug')) {
    prevNode.id = 'debug-' + prevNode.id;
  }
  if (preconditionNode) edges.push(createEdge(String(EdgeId++), preconditionNode.id, prevNode.id)); //use LastPreconditionID
  nodes.push(prevNode);
  // End of First Node
  //
  //

  for (let i = 1; i < orchestrationSteps.length; i++) {
    let orchStep = orchestrationSteps[i];
    let hasPrecondition = orchStep.preconditions.length > 0;
    let prevPreconditionNode = null;
    let preconditionNode = null;
    let firstNode = true;
    //prev is COmbinedSignInandSignUp or ClaimsProviderSelection
    let typesWithCPSelections = ['CombinedSignInAndSignUp', 'ClaimsProviderSelection'];
    let prevHasCPSelections = typesWithCPSelections.includes(orchestrationSteps[i - 1].type);

    if (hasPrecondition) {
      //for all preconditions
      // if (prevPreconditionNode) add edge between preconditions
      for (let j = 0; j < orchStep.preconditions.length; j++) {
        let precondition = orchStep.preconditions[j];
        prevPreconditionNode = preconditionNode;
        preconditionNode = createPreconditionNode(
          'precondition' + '-' + i.toString() + '-' + j.toString(), // orchstep-nthprecondition
          createPreconditionLabel(precondition.type, precondition.executeActionsIf, precondition.values),
          pX,
          (Y += 200),
        );
        if (firstNode) {
          while (precondtionNodesTobeConnected.length > 0) {
            let id = precondtionNodesTobeConnected.pop();
            if (id) edges.push(createRightEdge(String(EdgeId++), id, preconditionNode.id));
          }
          if (previousNodesTobeConnected.length > 0) {
            while (previousNodesTobeConnected.length > 0) {
              //connect all tp to current node
              let id = previousNodesTobeConnected.pop();
              if (id) edges.push(createEdge(String(EdgeId++), id, preconditionNode.id));
            }
          } else {
            edges.push(createEdge(String(EdgeId++), prevNode.id, preconditionNode.id));
          }
          firstNode = false;
        }
        if (prevPreconditionNode) {
          edges.push(createEdge(String(EdgeId++), prevPreconditionNode.id, preconditionNode.id));
        }
        nodes.push(preconditionNode);
        precondtionNodesTobeConnected.push(preconditionNode.id);
      }
    }
    // for all TP create a node
    if (prevHasCPSelections) {
      Y += 200;
      for (let i = 0; i < orchStep.claimsExchanges.length; i++) {
        let node = createNode(
          String(orchStep.order),
          String(orchStep.claimsExchanges[i].technicalProfilerefrenceId),
          orchStep.claimsExchanges[i].technicalProfilerefrenceId,
          nX + (i * 200 - orchStep.claimsExchanges.length * 100),
          Y,
          '',
        ); //need new label method
        if (node.data.label.toLowerCase().startsWith('debug')) {
          node.id = 'debug-' + node.id;
        }
        if (preconditionNode)
          //connect precondition to TP
          edges.push(createEdge(String(EdgeId++), preconditionNode.id, node.id)); //use LastPreconditionID
        else edges.push(createEdge(String(EdgeId++), prevNode.id, node.id));
        nodes.push(node);
        previousNodesTobeConnected.push(node.id); //maybe switch to prev nodes to be connected
      }
    } else {
      let node = createNode(
        String(orchStep.order),
        String(orchStep.order),
        createOrchStepLabel(orchStep),
        nX,
        (Y += 200),
        String(orchStep.subJourneyToInvoke),
      );
      if (node.data.label.toLowerCase().startsWith('debug')) {
        node.id = 'debug-' + node.id;
      }

      if (preconditionNode)
        edges.push(createEdge(String(EdgeId++), preconditionNode.id, node.id)); //use LastPreconditionID
      else {
        while (precondtionNodesTobeConnected.length > 0) {
          let id = precondtionNodesTobeConnected.pop();
          if (id) edges.push(createRightEdge(String(EdgeId++), id, node.id));
        }
        if (previousNodesTobeConnected.length > 0) {
          while (previousNodesTobeConnected.length > 0) {
            //connect all tp to current node
            let id = previousNodesTobeConnected.pop();
            if (id) edges.push(createEdge(String(EdgeId++), id, node.id));
          }
        } else {
          edges.push(createEdge(String(EdgeId++), prevNode.id, node.id));
        }
      }
      nodes.push(node);
      prevNode = node;
    }
  }
  return { nodes, edges };
}

export function evalExpression(condition: string, stepIndex: string, logJson: any) {
  // p1 and p2 are assumed to be properties if they can not be found as properties then they will be treated as a value
  // this is flawed in the scenario a value comparison was supposed to be made but there happened to be a property with the same value
  let [p1, comparision, p2] = condition.split(' ');
  let log: any;
  for (let i = 0; i < logJson.length; i++) {
    if (
      logJson[i].debugStepIndex === stepIndex &&
      logJson[i].debugIsVtp === false &&
      logJson[i].debugIsSubjourney === false
    ) {
      log = logJson[i];
      break;
    }
  }
  if (log?.hasOwnProperty(p1)) {
    p1 = log[p1];
  }
  if (log?.hasOwnProperty(p2)) {
    p2 = log[p2];
  }
  p1 = String(p1);
  if (p1.toLowerCase() == 'true' || p1.toLowerCase() == 'false') {
    p1 = p1.toLowerCase();
  }
  p2 = String(p2);
  if (p2.toLowerCase() == 'true' || p2.toLowerCase() == 'false') {
    p2 = p2.toLowerCase();
  }
  if (comparision == '==') {
    return p1 == p2;
  } else if (comparision == '!=') {
    return p1 != p2;
  }
}
